import { createFileRoute } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import { ListItemIcon, Menu, NavMenuItem } from '../../components/generic.tsx'
import { Icon } from '../../components/Icon.tsx'
import { IconButton } from '../../components/IconButton.tsx'
import { WithNavigation } from '../../components/Layouts.tsx'
import { Stack } from '../../components/Stack.tsx'
import { useMenu } from '../../components/useMenu.ts'
import { MeasurementsTable } from '../../features/measurements/table/MeasurementsTable.tsx'
import { ids } from '../../ids.ts'

export const Route = createFileRoute('/_app/measurements/')({ component: RouteComponent })

function RouteComponent() {
	return (
		<WithNavigation
			topBar={
				<Stack justify='end' align='center' flexGrow={1}>
					<OptionsMenu />
				</Stack>
			}
		>
			<MeasurementsTable />
		</WithNavigation>
	)
}

const OptionsMenu = () => {
	const { t } = useTranslation()
	const { openMenu, menuProps } = useMenu()
	return (
		<>
			<IconButton
				data-ta={ids.measurements.optionsBtn}
				icon='EllipsisV'
				label={t(($) => $.measurements.options)}
				variant='text'
				color='primary'
				size='large'
				onClick={openMenu}
			/>
			<Menu {...menuProps}>
				<NavMenuItem data-ta={ids.measurements.measurementReportsLink} color='primary' to='/reports/csv'>
					<ListItemIcon>
						<Icon name='ArrowDownToLine' />
					</ListItemIcon>
					{t(($) => $.measurements.reportsLink)}
				</NavMenuItem>
				<NavMenuItem data-ta={ids.measurements.viewDevicesLink} color='primary' to='/devices'>
					<ListItemIcon>
						<Icon name='SignalStream' />
					</ListItemIcon>
					{t(($) => $.measurements.viewDevices)}
				</NavMenuItem>
			</Menu>
		</>
	)
}
